import React from 'react';
import { Form, DatePicker } from 'antd';
const TurnRegularField = (props) => (<Form.Item {...props}>
    <DatePicker showToday placeholder='请选择'/>
  </Form.Item>);
TurnRegularField.defaultProps = {
    label: '转正时间',
};
export default TurnRegularField;
